import { Link } from "gatsby"
import { FC, useCallback, useMemo } from "react"

// utils
import { events } from "../../utils/heap/tracking_events"
import { returnUrlWithLangCodePrefixOnly } from "../../utils/general_utils"

// styles
import { header, relatedArticlesWrapper } from "./RelateArticles.module.scss"
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"

type Props = {
  articles: NonNullable<
    Queries.HelpArticleQuery["contentfulHelpArticle"]
  >["relatedArticles"]
  relatedArticlesHeader: { readonly raw: string | null } | null | undefined
}

const RelatedArticles: FC<Props> = ({ articles, relatedArticlesHeader }) => {
  if (!articles || articles?.length <= 0) {
    return null
  }

  const handleRelatedArticleClick = useCallback((title: string) => {
    events?.relatedArticleClick(title, RelatedArticles?.name)
  }, [])

  const relatedArticleHeader = useMemo(() => {
    if ((relatedArticlesHeader?.raw?.length ?? 0) > 0) {
      return documentToPlainTextString(
        JSON.parse(relatedArticlesHeader?.raw ?? "")
      )
    }

    return ""
  }, [relatedArticlesHeader])

  return (
    <div className={relatedArticlesWrapper}>
      <h2 className={header}>{relatedArticleHeader}</h2>
      <ul>
        {articles.map((art, index) => {
          return (
            <li key={`${art?.slug}__${index}`}>
              <Link
                to={
                  returnUrlWithLangCodePrefixOnly(
                    `/articles/${art?.articleId}/${art?.slug}`
                  ) ?? ""
                }
                onClick={() =>
                  handleRelatedArticleClick(
                    `${art?.helpArticleTitle} - /help/articles/${art?.articleId}/${art?.slug}`
                  )
                }
              >
                {art?.helpArticleTitle}
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default RelatedArticles
